module.exports = __webpack_public_path__ + "img/header-title04.398c0a86.png";